import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';

export interface RowGroupColumn {
  code: string;
  name: string;
  colId: string;
  field: string;
  isSelected: boolean;
  groupOrder?: number;
}

interface RowGroupColumnConfig {
  code: string;
  name: string;
  colId: string;
  field: string;
}

type DefaultGroupsSelector = (state: Store) => string[] | undefined;

export const useRowGroupColumns = (
  rowGroupColumns: RowGroupColumnConfig[],
  defaultGroupsSelector: DefaultGroupsSelector,
): RowGroupColumn[] => {
  const defaultRowGroups = useSelector(defaultGroupsSelector);

  return rowGroupColumns.map(({ code, name, colId, field }) => {
    const groupMatchingCode = new RegExp(code, 'i');
    const groupIndex = defaultRowGroups?.findIndex((group) => groupMatchingCode.test(group)) ?? -1;

    return {
      code,
      name,
      colId,
      field,
      isSelected: groupIndex !== -1,
      groupOrder: groupIndex !== -1 ? groupIndex : undefined,
    };
  });
};
